import { AnalysisDownloadGq, AnalysisDownloadGqProps } from './../../models/AnalysisDownloadGq';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import * as React from 'react';

export default function useDownloadAnalysisGq() {
  const [mutation, mutationResult] = useMutation<ResponseGq, Variables>(gqTag);

  return React.useCallback(
    (command: CommandGq) =>
      mutation({ variables: { command } }).then((result) => result.data.projects.downloadAnalysis),
    []
  );
}

const gqTag = gql`
  mutation DownloadContentPlan($command: DownloadAnalysisCommand!) {
    projects {
      downloadAnalysis(command: $command) {
        download { ${AnalysisDownloadGqProps} }
      }
    }
  }
`;

interface Variables {
  command: CommandGq;
}

export interface CommandGq {
  projectId: number;
  authenticationStorage: AuthenticationStorage[];
  screenshotConfigurations: ScreenshotConfiguration[];
  type: DownloadAnalysisType;
  theme: DownloadAnalysisTheme;
}

export type DownloadAnalysisType = 'slide' | 'screenshot';
export type DownloadAnalysisTheme = 'voxel' | 'pixel';

export interface AuthenticationStorage {
  key: string;
  value: string;
}

export interface ScreenshotConfiguration {
  chartId: string;
  analysisFilter: string;
  title: string;
}

export interface ResponseGq {
  projects: {
    downloadAnalysis: {
      download: AnalysisDownloadGq;
    };
  };
}
